/** @jsx jsx */
import { css, jsx } from '@emotion/react';

import * as React from 'react';
import { Link } from 'react-router';

import type { PatchedLocationDescriptor } from 'js/lib/connectToRouter';

import type { Theme } from '@coursera/cds-core';
import { ArrowPreviousIcon } from '@coursera/cds-icons';

import { TooltipWrapper } from 'bundles/common/components/Tooltip';

import _t from 'i18n!nls/grading';

const styles = {
  link: (theme: Theme) => css`
    width: 44px;
    height: 44px;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 4px;
    margin-right: ${theme.spacing(24)};

    &:hover {
      background-color: ${theme.palette.blue[100]};
    }

    &:focus {
      outline: none;
      text-decoration: none;
      background-color: ${theme.palette.blue[100]};
      border: 1px solid ${theme.palette.purple[600]};
      box-sizing: border-box;
      border-radius: 4px;
    }
  `,
  disabled: (theme: Theme) => css`
    pointer-events: none;
    color: ${theme.palette.gray[700]};
  `,
};

type Props = {
  routeOnClose: PatchedLocationDescriptor;
  tooltipMessage?: string;
  disabled?: boolean;
};

// Generic exit button for grading app
const ExitButton: React.FC<Props> = ({ routeOnClose, tooltipMessage, disabled }) => {
  return (
    <TooltipWrapper
      placement="bottom"
      tooltipId="BackToAssignmentGrading"
      delayShow={100}
      message={tooltipMessage || _t('Back')}
    >
      <Link to={routeOnClose} css={[styles.link, disabled && styles.disabled]} aria-label="Back">
        <ArrowPreviousIcon />
      </Link>
    </TooltipWrapper>
  );
};

export default ExitButton;
